import React, { useRef, useState } from 'react';
import { UploadCloud } from 'lucide-react';
import classes from '../templates.module.scss';
import { createCn } from '../../../helpers/utils';

const cn = createCn('templates', classes);

interface TemplateImportProps {
  importing: boolean;
  /** Возвращает true при успехе — компонент очищает выбранный файл только тогда. */
  onImport: (file: File) => Promise<boolean>;
}

const TemplateImport = ({ importing, onImport }: TemplateImportProps) => {
  const [file, setFile] = useState<File | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async () => {
    if (!file || importing) return;
    const ok = await onImport(file);
    if (ok) {
      setFile(null);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div className={cn('import')}>
      <div className={cn('import-title')}>Импорт из DOCX-образца</div>
      <p className={cn('import-hint')}>
        Загрузите DOCX корпоративного протокола — система создаст шаблон по его структуре.
      </p>

      <div className={cn('import-row')}>
        <input
          ref={inputRef}
          type="file"
          accept=".docx"
          disabled={importing}
          onChange={(e) => setFile(e.target.files?.[0] ?? null)}
        />
        <button
          type="button"
          className={cn('import-btn')}
          onClick={handleSubmit}
          disabled={!file || importing}
        >
          <UploadCloud size={16} /> {importing ? 'Импорт…' : 'Импортировать'}
        </button>
      </div>
    </div>
  );
};

export default TemplateImport;
